import * as types from "../actions/actionTypes"
const initialState = {
  loading:true,
  error:false,
  data: {costs:[], earnings:[]},
  meta:{cost_sum:0, earning_sum:0},
};

const BalanceSheet = (state = initialState, action) => {
  switch (action.type) {
    case types.GET_BALANCE_SHEET_REQUEST:
      return { ...state, ...action.payLoad};
    case types.GET_BALANCE_SHEET_SUCCESS:
      return { ...state, ...action.payLoad };
    case types.GET_BALANCE_SHEET_FAILURE:
      return { ...state, ...action.payLoad};
    default:
      return state;
  }
};

export default BalanceSheet;